export default __webpack_public_path__ + "static/media/Login-background.1bd432af.webp";